import { makeStyles } from '@mui/styles'
import { useTheme } from '@mui/material/styles'
import common from 'shared/styles'

const useStyles = makeStyles(() => {
    const theme = useTheme()

    return {
        success: {
            ...common.flexJustityAlignCenter,
            height: 111,
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
            color: theme.palette.secondary[600],

        },
        failure: {
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            padding: 50,
            color: theme.palette.secondary[600],

        },
        failureInfo: {
            width: '50%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',

        },
        stickers: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            paddingTop: 20,
            paddingBottom: 20,
        },
        text: {
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
            color: theme.palette.secondary[600],
        },
        tempValue: {
            fontWeight: 900,
            color: theme.palette.secondary[600],
        },
        actions: { ...common.flexJustityAlignCenter },
        button: {
            ...theme.custom.button,
            margin: '15px 25px 15px 25px',
        },
    }
})

export default useStyles
